import {createStructuredSelector} from 'reselect';
import {getStage} from '~/selectors/WelcomeSelectors';
import {isDirty, isFetching} from '~/selectors/DesignSelectors';
import {
  allStylesLoaded,
  didSelectedStyleLoadError,
  getStyleSelections,
  getAnchorStyleId,
  getAnchorStyle,
  getCurrentColorId,
  isAnchorDebossed,
  isAnchorEmbossed,
  isAnchorEmbroidered,
  isAnchorLaserEngraved
} from '~/selectors/ProductSelectors';
import {
  isMultiItemEligible,
  isStreamlinedMobileMode,
  streamlinedMobileIntent,
  simplePricingTestEnabled,
  isDragNDropAnywhereEnabled,
  wtoTestEnabled
} from '~/selectors/ConfigSelectors';
import {setOrderOptionsPath} from '~/slices/pathSlice';

export const select = () => {
  return createStructuredSelector({
    allStylesLoaded,
    didSelectedStyleLoadError,
    welcomeStage: getStage,
    fetchingDesign: isFetching,
    selectedStyles: getStyleSelections,
    anchorStyle: getAnchorStyle,
    anchorStyleId: getAnchorStyleId,
    currentColorId: getCurrentColorId,
    isAnchorDebossed,
    isAnchorEmbossed,
    isAnchorLaserEngraved,
    isDirty,
    isDragNDropAnywhereEnabled,
    isMultiItemEligible,
    isAnchorEmbroidered,
    isStreamlinedMobileMode,
    wtoTestEnabled,
    streamlinedMobileIntent,
    simplePricingTestEnabled
  });
};

import {bindActionCreators as bind} from 'redux';
import {location, updateInternalUser} from '~/actions/AccountActions';
import {setLabMode} from '~/actions/LabModeActions';
import {
  addSignals,
  loadCartCookie,
  setCartMode,
  setStreamlinedMobileIntent,
  setStreamlinedMobileMode,
  updateSleevePrintOverride
} from '~/actions/ConfigActions';
import * as analyticsActions from '~/actions/AnalyticsActions';
import {loadStyles, loadStyleVariants} from '~/actions/CatalogActions';
import {fetch} from '~/actions/DesignActions';
import {
  replaceProductsCartMode,
  swapProduct,
  updateStylesCategoryPaths,
  validateActiveProducts,
  getCategoryPathForStyleId
} from '~/actions/ProductActions';
import {setPreferSingles} from '~/actions/AccountActions';
import {setLabBlankLoad, enableSleeveNav} from '~/actions/CanvasActions';
import {loadFontAutofillData} from '~/actions/FontActions';
import {prompt} from '~/actions/NotificationActions';
import {deselectAllIcons} from '~/actions/SelectionActions';
import {reuseAccountUpload} from '~/actions/UploadActions';

// api
import {cartEndpoints} from '~/api/designs/cartApi';
import {updateProductQuantities} from '../../actions/QuoteActions';

export const actions = dispatch => {
  return {
    ...bind(
      {
        addSignals,
        deselectAllIcons,
        enableSleeveNav,
        getCart: cartEndpoints.getCart.initiate,
        getCategoryPathForStyleId,
        loadCartCookie,
        loadDesign: fetch,
        loadFontAutofillData,
        loadStyles,
        loadStyleVariants,
        location,
        onWillMount: setLabMode,
        prompt,
        replaceProductsCartMode,
        setCartMode,
        setLabBlankLoad,
        setOrderOptionsPath,
        setPreferSingles,
        setStreamlinedMobileIntent,
        setStreamlinedMobileMode,
        swapProduct,
        updateStylesCategoryPaths,
        updateInternalUser,
        updateSleevePrintOverride,
        updateProductQuantities,
        upload: reuseAccountUpload,
        validateActiveProducts
      },
      dispatch
    ),
    meta: bind(analyticsActions, dispatch)
  };
};
